/*
 * feature-badge
 */
import {
	Badge,
	type BadgeProps,
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@psychology/react-ui"
import type { ReactNode } from "react"

type FeatureBadgeProps = BadgeProps & {
	label: ReactNode
}

export function FeatureBadge({ label, children, ...props }: FeatureBadgeProps) {
	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger
					className="inline-flex items-center"
					onClick={(e) => {
						e.preventDefault()
						e.stopPropagation()
					}}
				>
					<Badge {...props}>{children}</Badge>
				</TooltipTrigger>
				<TooltipContent>{label}</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	)
}
